function gramsToKilograms(val = 0) {
  return (val / 1000).toFixed(1);
}

export {
  gramsToKilograms
}